module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "featured"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 featured-slogan"
  }, [_c('h3', [_vm._v(_vm._s(_vm.user.uid))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.user.email))]), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('tevaGaleria')))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.galeria
    }
  }, [_vm._v(_vm._s(_vm.galeria))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.galeria),
      expression: "galeria",
      arg: "copy"
    }]
  }, [_vm._v(_vm._s(_vm.$t('copiar')))])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-524b75ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/perfil/components/perfil-featured/perfil-featured.vue
// module id = 306
// module chunks = 0